// Figma: RGM Landing Page > Navbar V2 header > notifications.
// `assets/svg/Bell.tsx` is a 26x24 icon with a hardcoded stroke and is unreferenced; this one
// is sized for the 54px header and takes the header's text colour.
const BellOutline = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 2.92c-2.42 0-4.38 1.96-4.38 4.37v3.05L4.38 13.2h11.24l-1.24-2.86V7.29c0-2.41-1.96-4.37-4.38-4.37Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.13 15.2c.31.88.99 1.46 1.87 1.46s1.56-.58 1.87-1.46"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
        />
    </svg>
);

export default BellOutline;
